
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $4AGbv = parcelRequire("4AGbv");

var $iNA1s = parcelRequire("iNA1s");
(0, $4AGbv.default).registerPlugin((0, $iNA1s.ScrollTrigger));
const $d76ba1c9e8149b1e$var$list = [
    {
        name: "\u805A\u81FB\u57CE\u5730\u6807\u4F9B\u5E94\u94FE\u5E73\u53F0",
        href: 'jlscp.html'
    }
];
// joinIn.addEventListener('click', () => {
//     //跳转
//     window.open('/joinIn.html','_self');
// })
window.addEventListener('load', ()=>{
    $d76ba1c9e8149b1e$var$toAboutUsAdJoinIn();
    const nav = document.querySelector('.nav-ul');
    const line = document.querySelector('.underline');
    //定时器
    let timer;
    const path = window.location.pathname;
    if (path == '/iprp.html') {
        const navbar = document.querySelector('.navbar');
        navbar.style.backgroundColor = 'rgba(41, 52, 60,0.9)';
    } else {
        $d76ba1c9e8149b1e$var$navbarScroll();
        $d76ba1c9e8149b1e$var$init(nav, line);
    }
    // 添加点击事件监听器
    nav.addEventListener('click', (event)=>{
        if (event.target.classList.contains('nav-item')) console.log("\u70B9\u51FB\u4E86:", event.target.textContent);
    });
    // 添加鼠标悬停事件监听器
    nav.addEventListener('mouseover', (event)=>{
        if (event.target.classList.contains('nav-item')) {
            console.log("\u9F20\u6807\u60AC\u505C\u5728:", event.target.textContent);
            //获取当前元素距离父元素的左侧距离
            clearTimeout(timer);
            let offsetLeft;
            if (event.target.textContent == "\u77E5\u8BC6\u4EA7\u6743\u7EF4\u6743") offsetLeft = event.target.offsetLeft;
            else offsetLeft = event.target.offsetLeft + 30;
            //设置下划线的宽度和位置
            line.style.left = `${offsetLeft}px`;
        // 执行鼠标悬停时的逻辑
        }
    });
    // 添加鼠标移出事件监听器
    nav.addEventListener('mouseout', (event)=>{
        if (event.target.classList.contains('nav-item')) {
            console.log("\u9F20\u6807\u79FB\u51FA\u4E86:", event.target.textContent);
            // 执行鼠标移出时的逻辑
            timer = setTimeout(()=>{
                clearTimeout(timer);
                $d76ba1c9e8149b1e$var$init(nav, line);
            }, 500);
        }
    });
    //鼠标点击事件
    nav.addEventListener('click', (event)=>{
        if (event.target.classList.contains('nav-item')) {
            const index = Array.from(nav.children).indexOf(event.target);
            //跳转
            if (index == 0) //设置target跳转方式
            window.open('/jlscp.html', '_self');
            else if (index == 1) window.open('/ciprip.html', '_self');
            else if (index == 2) window.open('/ipfes.html', '_self');
            else if (index == 3) window.open('/rightsProtection.html', '_self');
            else if (index == 4) window.open('/dg-ad.html', '_self');
        }
    });
});
//默认下标
function $d76ba1c9e8149b1e$var$init(nav, line) {
    //从本地获取index
    let index;
    //获取路由信息
    const path = window.location.pathname;
    if (path == '/') index = -1;
    if (path == '/jlscp.html') index = 0;
    if (path == '/ciprip.html') index = 1;
    if (path == '/ipfes.html') index = 2;
    if (path == '/rightsProtection.html') index = 3;
    if (path == '/dg-ad.html') index = 4;
    console.log('path', path);
    // const index = -1;
    //取nav第二个子元素
    const item = nav.children[index];
    //获取当前元素距离父元素的左侧距离
    let offsetLeft;
    if (index == -1) offsetLeft = -100;
    else if (index == 3) offsetLeft = item?.offsetLeft;
    else offsetLeft = item?.offsetLeft + 30;
    // let offsetLeft = index == -1?-100:item.offsetLeft+30;
    //设置下划线的宽度和位置
    line.style.left = `${offsetLeft}px`;
    //过渡
    line.style.transition = 'all 0.5s ease';
}
function $d76ba1c9e8149b1e$var$navbarScroll() {
    //监听页面的滚动 超出200px时 显示导航栏背景 使用gsap和scrollTrigger插件
    const navbar = document.querySelector('.navbar');
    (0, $iNA1s.ScrollTrigger).create({
        trigger: document.body,
        start: "100 -100",
        onEnter: ()=>(0, $4AGbv.default).to(navbar, {
                backgroundColor: "rgba(41, 52, 60,0.9)",
                duration: 0.1
            }),
        onLeaveBack: ()=>(0, $4AGbv.default).to(navbar, {
                backgroundColor: "transparent",
                duration: 0.1
            }),
        toggleActions: "play none none reverse"
    });
}
function $d76ba1c9e8149b1e$var$toAboutUsAdJoinIn() {
    const toAboutUs = document.querySelector('.btn_about_us');
    const toJoinIn = document.querySelector('.join_in');
    toAboutUs.addEventListener('click', ()=>{
        //跳转
        window.open('/aboutUs.html', '_self');
    });
    toJoinIn.addEventListener('click', ()=>{
        //跳转
        window.open('/joinUs.html', '_self');
    });
}


//# sourceMappingURL=a.b280f0db.js.map
